import React from 'react';
import { Link, Routes, Route } from 'react-router-dom';
import { combineClassNames } from 'core/css';
import { Translate, TranslateHTML } from 'core/translate';
import { CLASSNAME_UPDATING } from '../../../../constants';
import DriveTypeToggle from '../driveTypeToggle/DriveTypeToggle';
import { SvgIcon } from 'core/icons';
import { useModelInfo } from '../../../../common/ModelInfoContext';
import DriveTypeDetailModal from '../driveTypeDetailModal/DriveTypeDetailModal';

const DriveTypeFilter = ({
  isUpdating,
  uniqueDriveAndWheelTypes,
  selections,
  onDriveChange,
  isSelectionRevealed,
  onClose,
}) => {
  const { isEvMode } = useModelInfo();
  const hasOneDriveType = uniqueDriveAndWheelTypes.length === 1;
  const analyticsKeyDriveToggle = isEvMode
    ? 'electric drive system'
    : 'drive type';
  const DriveTypeLink = () => {
    return (
      <Link
        to={`driveTypes`}
        className="drive-type-link__container stat-button-link"
        data-dtm={analyticsKeyDriveToggle}>
        <SvgIcon name="info" className="drive-type-link__icon" />
        <TranslateHTML
          as="span"
          className="drive-type-link__label"
          value="performance.details.v3"
        />
      </Link>
    );
  };

  const { driveType } = selections;

  return (
    <>
      {hasOneDriveType ? null : (
        <>
          <div
            className={combineClassNames(
              'drive-type-container',
              isUpdating && CLASSNAME_UPDATING
            )}>
            {isEvMode ? (
              <div className="drive-type__ev-container">
                <TranslateHTML
                  as="div"
                  className="drive-type-container__label drive-type-container__label--ev"
                  value="electric.drive.system.v3"
                />
                <DriveTypeLink code={driveType} />
              </div>
            ) : (
              <div className="drive-type-container__label">
                <Translate value="component.common.select.drive.type"></Translate>
              </div>
            )}
            <DriveTypeToggle
              options={uniqueDriveAndWheelTypes}
              selections={selections}
              onChange={onDriveChange}
              isSelectionRevealed={isSelectionRevealed}
              analyticsKey={analyticsKeyDriveToggle}
            />
          </div>
          <Routes>
            <Route
              path={`/driveTypes`}
              element={<DriveTypeDetailModal onClose={onClose} />}
            />
          </Routes>
        </>
      )}
    </>
  );
};

export default DriveTypeFilter;
